<template>
  <div class="plotLegend-ctn">
    <svg width="363px" height="67px" viewBox="0 0 322 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>编组 2</title>
      <defs>
        <rect id="path-1" x="9" y="117.5" width="16" height="95" rx="1" />
        <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="16" height="95" fill="white">
          <use xlink:href="#path-1" />
        </mask>
      </defs>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="画板" transform="translate(-119.000000, -859.000000)">
          <g id="编组-3" transform="translate(119.500000, 859.000000)">
            <g id="编组-2" transform="translate(160.750000, 27.000000) rotate(-90.000000) translate(-160.750000, -27.000000) translate(133.750000, -133.750000)">
              <use id="矩形" stroke="#A7A7A7" mask="url(#mask-2)" stroke-dasharray="4,1" xlink:href="#path-1" />
              <g id="编组-13备份-3" transform="translate(0.000000, 19.500000)">
                <path id="直线-14" d="M14.2727273,-1 L14.2727273,1 L8.272,1 L8.272,269 L14.2727273,269 L14.2727273,271 L0.272727273,271 L0.272727273,269 L6.272,269 L6.272,0.999 L0.272727273,1 L0.272727273,-1 L8.27272727,-1 L8.272,-0.999 L14.2727273,-1 Z" fill="#979797" fill-rule="nonzero" />
                <rect id="矩形" stroke="#A7A7A7" fill="#6CD27E" x="0.5" y="98" width="15" height="95" />
                <polygon id="矩形备份-41" fill="#FFFFFF" transform="translate(7.425005, 145.352355) rotate(45.000000) translate(-7.425005, -145.352355) " points="3.42500535 141.352355 10.88574 141.89162 11.4250053 149.352355 3.9642707 148.813089" />
              </g>
              <text id="Maxium" transform="translate(41.000000, 20.000000) rotate(90.000000) translate(-41.000000, -20.000000) " font-family="OriyaSangamMN, Oriya Sangam MN" font-size="10" font-weight="normal" fill="#000000">
                <tspan x="21" y="23.5">{{$t('Maxium')}}</tspan>
              </text>
              <text id="75%-percentile" transform="translate(41.000000, 94.500000) rotate(90.000000) translate(-41.000000, -94.500000) " font-family="OriyaSangamMN, Oriya Sangam MN" font-size="10" font-weight="normal" fill="#000000">
                <tspan x="14" y="91.5">75%</tspan>
                <tspan x="14" y="104.5">{{$t('percentile')}}</tspan>
              </text>
              <text id="Median" transform="translate(41.500000, 165.000000) rotate(90.000000) translate(-41.500000, -165.000000) " font-family="OriyaSangamMN, Oriya Sangam MN" font-size="10" font-weight="normal" fill="#000000">
                <tspan x="23" y="168.5">{{$t('Median')}}</tspan>
              </text>
              <text id="25%-percentile" transform="translate(41.000000, 240.500000) rotate(90.000000) translate(-41.000000, -240.500000) " font-family="OriyaSangamMN, Oriya Sangam MN" font-size="10" font-weight="normal" fill="#000000">
                <tspan x="14" y="237.5">25% </tspan>
                <tspan x="14" y="250.5">{{$t('percentile')}}</tspan>
              </text>
              <text id="Minimum" transform="translate(41.500000, 298.000000) rotate(90.000000) translate(-41.500000, -298.000000) " font-family="OriyaSangamMN, Oriya Sangam MN" font-size="10" font-weight="normal" fill="#000000">
                <tspan x="18" y="301.5">{{$t('Minimum')}}</tspan>
              </text>
              <line x1="10.1851852" y1="19.5" x2="29.8148148" y2="19.5" id="直线-8" stroke="#979797" stroke-width="0.5" stroke-linecap="round" stroke-dasharray="2,1" />
              <line x1="16.5" y1="165" x2="29.5" y2="165" id="直线-8备份-2" stroke="#979797" stroke-width="0.5" stroke-linecap="round" stroke-dasharray="2,1" />
              <line x1="10.1851852" y1="289.5" x2="29.8148148" y2="289.5" id="直线-8备份" stroke="#979797" stroke-width="0.5" stroke-linecap="round" stroke-dasharray="2,1" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CChartPlotLegend',
  mixins: [reDrawTrigger],
  props: {},
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.plotLegend-ctn {
  display: inline-block;
}
</style>
